<template>
  <div class="que-detail">
    <div v-for="(title, index) in titles" :key="index" class="title-item">
      <div class="title-head">
        <span class="index">{{ title.sort }}.</span>
        <span class="type">({{ typeLabel[title.type] }})</span>
        <span class="name">{{ title.name }}</span>
      </div>
      <div v-if="title.type != 3" class="title-options">
        <div class="option" v-for="(option, index) in title.options" :key="index">
          <span
            :class="[
              title.type === 1 ? 'radio' : title.type === 2 ? 'checkbox' : '',
              option.isCorrect === 1 ? 'correct' : ''
            ]"
            class="num"
            >{{ option.name }}</span
          >
          <div class="label">{{ option.content }}</div>
        </div>
      </div>
      <div class="title-ans" v-else>
        <span>共提交{{ title.answersCount ? title.answersCount : 0 }}份答案</span>
      </div>
    </div>
    <!-- footer 0 -->
    <div v-if="status == 0" class="que-detail-footer">
      <div class="checkbox">
        <van-checkbox shape="square" v-model="checked">允许游客答题</van-checkbox>
      </div>
      <div class="pub-btn">
        <div @click="reSend" class="pub">发布</div>
        <div @click="handle2Edit" class="edit">编辑</div>
      </div>
    </div>

    <div v-if="status == 1" class="que-detail-footer">
      <div class="checkbox" style="color:#909399;fontSize:14px">
        默认24小时后自动停止
      </div>
      <div class="pub-btn">
        <span @click="handle2AnswerDetail"
          >共提交 <span style="color:rgba(68,101,243,1)">{{ answerCount }}</span> 人</span
        >
        <div @click="stop" class="stop">停止答题</div>
      </div>
    </div>

    <div v-if="status == 2" class="que-detail-footer">
      <div class="checkbox">
        <van-checkbox shape="square" v-model="checked">允许游客答题</van-checkbox>
      </div>
      <div class="pub-btn">
        <span @click="handle2AnswerDetail"
          >共提交 <span style="color:rgba(68,101,243,1)">{{ answerCount }}</span> 人</span
        >
        <div @click="reSend" class="edit">再次发布</div>
      </div>
    </div>
  </div>
</template>

<script>
import {getbase, getbasetotal, releasebase, simpleStop} from '@/api'
// eslint-disable-next-line no-unused-vars
import {wsMixin} from '@/views/activePlay/wsMixin.js'
export default {
  mixins: [wsMixin],
  data() {
    return {
      typeLabel: ['', '单选', '多选', '问答'],
      /* 0-没有答 1-正在答 2-已答完  */
      status: this.$route.query.status,
      id: this.$route.params.id,
      paperId: this.$route.query.paperId,
      titles: [],
      checked: false,
      answerCount: 0
    }
  },
  created() {
    if (this.status === '0') {
      this.getDetail()
    } else {
      this.getStatus2Detail()
    }
  },
  methods: {
    async getDetail() {
      const result = await getbase({paperId: this.paperId})
      if (result.code === 0) {
        this.titles = result.data.titles || []
      }
    },
    async getStatus2Detail() {
      const result = await getbasetotal({paperId: this.paperId, eventId: this.id})
      if (result.code === 0) {
        this.titles = result.data.titles || []
        this.answerCount = result.data.answerCounts || 0
      }
    },
    // 编辑
    handle2Edit() {
      this.$router.push(`/activeAddQue/${this.id}?paperId=${this.paperId}`)
    },
    // 查看回答详情
    handle2AnswerDetail() {
      this.$router.push(`/activeAnsDetail/${this.id}?paperId=${this.paperId}`)
    },
    /* 再次发布 */
    async reSend() {
      if (!this.wsOpen) {
        return this.$Toast.success('发布失败，请重试')
      }
      const params = {
        eventId: this.id,
        paperId: this.paperId,
        type: 2,
        allowVisitors: this.checked ? 1 : 2
      }
      const result = await releasebase(params)
      if (result.code === 0) {
        const obj = {
          c: 30001,
          a: {
            isCheckbox: '', // isCheckbox: 1. 单选 2. 多选
            objectId: this.paperId, // 答题卡id
            objectType: 1 // type 1. 标准出题  2. 快速出题
          },
          e: this.id
        }
        this.ws.send(JSON.stringify(obj))
        this.$Toast.success('发布成功')
        setTimeout(() => {
          this.$router.replace(`/activeQueList/${this.id}`)
        }, 2000)
      }
    },
    async stop() {
      if (!this.wsOpen) {
        return this.$Toast.success('停止失败，请重试')
      }
      const params = {
        eventId: this.id,
        paperId: this.paperId
      }
      const result = await simpleStop(params)
      if (result.code === 0) {
        const obj = {
          c: 30001,
          a: {
            isCheckbox: '', // isCheckbox: 1. 单选 2. 多选
            objectId: this.paperId, // 答题卡id
            objectType: 1, // type 1. 标准出题  2. 快速出题
            stop: 1
          },
          e: this.id
        }
        this.ws.send(JSON.stringify(obj))
        this.$Toast.success('停止成功')
        setTimeout(() => {
          this.$router.replace(`/activeQueList/${this.id}`)
        }, 2000)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.que-detail {
  position: relative;
  padding: 10px 10px 100px;
}

.title-item {
  margin-bottom: 30px;
  .title-head {
    .index {
      color: rgba(48, 49, 51, 1);
      font-weight: 700;
    }
    .type {
      color: rgba(192, 196, 204, 1);
      margin: 0 4px;
    }
    .name {
      word-break: break-all;
      color: rgba(48, 49, 51, 1);
      font-weight: 700;
    }
  }
  .title-ans {
    margin-top: 20px;
    text-align: center;
    color: rgba(68, 101, 243, 1);
    background: #f1f3f6;
    line-height: 40px;
  }
  .title-options {
    .option {
      margin-top: 20px;
      position: relative;
      padding-left: 40px;
    }
    .num {
      position: absolute;
      left: 0;
      top: 0;
      display: inline-block;
      width: 28px;
      height: 28px;
      text-align: center;
      line-height: 28px;
      background: #eef0f3;
      color: #333333;
      &.radio {
        border-radius: 50%;
      }
      &.checkbox {
        border-radius: 4px;
      }
      &.correct {
        color: #fff;
        background: rgba(9, 165, 46, 1);
      }
    }
    .label {
      text-align: justify;
      color: #606266;
      word-break: break-all;
    }
  }
}

.que-detail-footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  .checkbox {
    padding: 6px 6px;
    background: #f4f6f9;
  }
  .pub-btn {
    display: flex;
    align-items: center;
    justify-content: space-around;
    height: 70px;
    background: #fff;
    div {
      width: 46%;
      height: 45px;
      border-radius: 47px;
      text-align: center;
      line-height: 45px;
      color: #fff;
    }
    div.pub {
      background: rgba(74, 134, 246, 0.2);
      color: rgba(74, 134, 246, 1);
    }
    div.edit {
      background: rgba(74, 134, 246, 1);
    }
  }
  // =====
  .stop {
    background: linear-gradient(90deg, #fda423, #f39e23);
  }
}
</style>
